import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './styles/header.module.css';
import { Button, Col, Dropdown, Menu, Row, Tooltip } from 'antd';
import {
  CloseOutlined,
  EllipsisOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { hideChatbotWithDelay } from '@/store/slices/chatbotVisibility';
import { resetFlow } from '@/store/slices/middleware/chatbotFlowThunk';

const Header = props => {
  const dispatch = useDispatch();

  const logo = useSelector(
    state =>
      state.chatbotDetails.logo ||
      state.chatbotDetails?.company?.logo ||
      `${import.meta.env.BASE_URL}/elay.png`
  );

  const isChatbotVisible = useSelector(
    state => state.chatbotVisibility.isVisible
  );
  const settings = useSelector(state => state.chatbotDetails.settings);

  const onMenuClick = ({ key }) => {
    switch (key) {
      case 'privacy':
        let link = settings?.privacyLink || 'https://elay.io/privacy-policy';
        if (link.startsWith('http://') || link.startsWith('https://'))
          window.open(link, '_blank');
        else window.open('https://' + link, '_blank');
        break;
      case 'restart':
        dispatch(resetFlow());
        break;
      default:
        break;
    }
  };

  const tooltipProps = {};
  if (!isChatbotVisible) {
    tooltipProps['open'] = false;
    tooltipProps['overlayStyle'] = { display: 'none' };
    tooltipProps['mouseLeaveDelay'] = 10;
  }

  const menu = (
    <Menu onClick={onMenuClick}>
      <Menu.Item key={'privacy'} icon={<SafetyCertificateOutlined />}>
        <span>Privacy Policy</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Row
      className={styles.wrapper}
      align={'middle'}
      style={{
        backgroundColor: settings?.color || '#1aaafd',
        color: settings?.color,
      }}
    >
      <Col span={20}>
        <div className={styles.brand}>
          <div className={styles['logo-wrapper']}>
            <img className={styles.logo} src={logo} alt="" />
          </div>
          <span
            style={{
              color: '#F7F7F7',
            }}
            className={styles.title}
          >
            {settings?.headerTitle || 'Elay'}
          </span>
        </div>
      </Col>
      {!props?.hideCloseBtn && <Col span={4} className={styles.col_button}>
          <Button
            type="text"
            icon={<CloseOutlined style={{ fontSize: '20px', color: '#fff' }} />}
            onClick={() => dispatch(hideChatbotWithDelay(500))}
            className={styles.button}
          />
      </Col>}
    </Row>
  );
};

Header.propTypes = {
  hideCloseBtn: PropTypes.bool,
  logo: PropTypes.string,
  isChatbotVisible: PropTypes.bool,
  settings: PropTypes.object,
};

export default Header;
